
import { httpsCallable } from 'firebase/functions';
import { functions } from '../config/firebase-config';

interface UploadShopifyProductsContnetRequest {
    id: string,
}



const uploadShopifyProductImagesContent = async (id: string): Promise<null> => {
    const uploadShopifyProductImagesContent = httpsCallable<UploadShopifyProductsContnetRequest, null>(functions, 'upload_shopify_product_images_content');
    const result = await uploadShopifyProductImagesContent({ id });
    return null;
};

export { uploadShopifyProductImagesContent };